import i18n from '../../../../VueI18n'
import { InterestVariableEnum } from '../../../../@core/@shared/domain/enums/InterestVariable.enum'

/**
 * Reaproveita os rotulos das variaveis biometricas do dashboard, que ja estao
 * traduzidos em pt/en/es -- ver VariaveisBiometricasDashboard.js. As chaves sao
 * o inverso do mapa em modules/dashboard/constants/InterestVariableMap.ts.
 */
const INTEREST_VARIABLE_TO_LABEL_KEY: Record<InterestVariableEnum, string> = {
	[InterestVariableEnum.VOLUME_TOTAL_COM_CASCA]: 'volumeTotalComCasca',
	[InterestVariableEnum.VOLUME_TOTAL_SEM_CASCA]: 'volumeTotalSemCasca',
	[InterestVariableEnum.VOLUME_INDIVIDUAL_COM_CASCA]: 'arvoresMedVolumeTotalComCasca',
	[InterestVariableEnum.VOLUME_INDIVIDUAL_SEM_CASCA]: 'arvoresMedVolumeTotalSemCasca',
	[InterestVariableEnum.INCREMENTO_MEDIO_ANUAL_COM_CASCA]: 'imaComCasca',
	[InterestVariableEnum.INCREMENTO_MEDIO_ANUAL_SEM_CASCA]: 'imaSemCasca',
	[InterestVariableEnum.AREA_BASAL]: 'areaBasal',
	[InterestVariableEnum.DIAMETRO_MEDIO_QUADRATICO]: 'dg',
	[InterestVariableEnum.DAP_MAXIMO]: 'dapMaximo',
	[InterestVariableEnum.DAP_MEDIO]: 'dapMedio',
	[InterestVariableEnum.DAP_MINIMO]: 'dapMinimo',
	[InterestVariableEnum.ALTURA_TOTAL_MAXIMA]: 'alturaMaxima',
	[InterestVariableEnum.ALTURA_TOTAL_MEDIA]: 'alturaMedia',
	[InterestVariableEnum.ALTURA_TOTAL_MINIMA]: 'alturaMinima',
	[InterestVariableEnum.ALTURA_DOMINANTE]: 'alturaDominante',
	[InterestVariableEnum.NUMERO_DE_FUSTES]: 'numeroDeFustes',
	[InterestVariableEnum.NUMERO_DE_FUSTES_UTEIS]: 'arvoresUteis',
	[InterestVariableEnum.PROPORCAO_DE_FUSTES_UTEIS]: 'proporcaoArvoresUteis',
}

/**
 * Traduz em tempo de chamada (nao no escopo do modulo) para acompanhar a troca
 * de idioma. Variavel sem rotulo mapeado cai no proprio valor do enum em vez de
 * renderizar vazio.
 */
export const interestVariableLabel = (interestVariable: InterestVariableEnum): string => {
	const labelKey = INTEREST_VARIABLE_TO_LABEL_KEY[interestVariable]

	return labelKey ? (i18n.t(labelKey) as string) : interestVariable
}
